import { userMonthly, toQuarters, derive, pctChange, computeSheet, gapHeatmap } from "./pickerSheet";

const SUM = ["visits", "qty", "worked", "lost", "days", "absent"];

export function teamMonthly(raw, months, cfg) {
  const perUser = raw.users.map((u) => ({ id: u.id, rows: userMonthly(u, raw.days?.[u.id], months, cfg) }));
  const team = months.map((m, i) => {
    const t = { key: m, months: 1, active: 0, ...Object.fromEntries(SUM.map((k) => [k, 0])) };
    perUser.forEach(({ rows }) => {
      SUM.forEach((k) => { t[k] += rows[i][k]; });
      if (rows[i].days) t.active++;
    });
    return derive(t);
  });
  return { perUser, team };
}

export const quarterKeys = (team) => toQuarters(team).map((q) => q.key);

export function quarterReview(perUser, qa, qb, metric, minHours = 20) {
  return perUser.map(({ id, rows }) => {
    const qs = toQuarters(rows);
    const a = qs.find((q) => q.key === qa), b = qs.find((q) => q.key === qb);
    if (!a || !b || a.hrs < minHours || b.hrs < minHours) return null;
    const change = pctChange(b[metric], a[metric]);
    if (change == null) return null;
    return { id, a: a[metric], b: b[metric], change, score: metric === "lostDay" ? -change : change };
  }).filter(Boolean).sort((x, y) => y.score - x.score);
}

export function lastDataDay(raw) {
  let max = "";
  Object.values(raw.days || {}).forEach((ud) => Object.keys(ud).forEach((k) => { if (k > max) max = k; }));
  return max;
}

export function fullMonths(months, lastDay) {
  if (!lastDay) return months;
  const [y, m, d] = lastDay.split("-").map(Number);
  const dim = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return d >= dim - 3 ? months : months.slice(0, -1);
}

export function peakGapHour(raw, from, to, cfg) {
  const users = computeSheet(raw.days, from, to, cfg);
  const { grid } = gapHeatmap(users);
  const hours = Array.from({ length: 24 }, (_, h) => grid.reduce((s, r) => s + r[h], 0));
  const h = hours.indexOf(Math.max(...hours));
  return { hour: h, minutes: hours[h], users };
}
